const commonUrl = import.meta.env.VITE_API_BASE_URL

export default commonUrl
